import { notification } from 'antd/lib'
import { useUserDetails } from 'Contexts/UserDetailsContext'
import useService from 'Hooks/use-service'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getExamsByUserId } from 'Services/exams.service'

export const useExamList = () => {
    const userDetails = useUserDetails()
    const navigate = useNavigate()

    const { data, isLoading, error, trigger } = useService(getExamsByUserId)

    useEffect(() => {
        const userId = userDetails?.userID
        if (!userId) return
        trigger(userId)
    }, [trigger, userDetails?.userID])

    useEffect(() => {
        if (error) {
            notification.error({
                message: (error as Error).message ?? 'Error in loading exams',
                description:
                    'Please try again. If you still face the issue, reach out to the project owner',
                placement: 'bottomLeft',
            })
            navigate(`/`, { replace: true })
        }
    }, [error, navigate])

    return { data, isLoading, error }
}
